// frontend/src/pages/learning/Assignment.jsx
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Textarea } from '../../components/utils/Input';
import Loader from '../../components/utils/Loader';
import { useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import './styles/AssignmentTopics.css';


const Assignment = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const { assignmentId } = useParams();
  const [fetchData, { loading }] = useFetch();
  const [assignment, setAssignment] = useState(null);
  const [error, setError] = useState(null);

  const { state } = useLocation();
  // console.log('Location State:', state);

  // Retrieve state from location
  const location = useLocation();
  // console.log("Location:",location);
  // const { state } = location || {};
  const { owner, code, title, topictype, desc } = state || {};
// console.log("Title ",state);
  const [formData, setFormData] = useState({
    userAssignmentID: 0,
    assignmentType: "",
    assignmentFor: "None",
    category: "None",
    subCategory: "None",
    owner: owner || "",
    code: code || "",
    topicType: topictype || "",
    concernArea: title || "",
    desc: desc || "",
    problemStatement: "",
    why1: "",
    why2: "",
    why3: "",
    why4: "",
    why5: "",
    rootCause: "",
    summary: "",
    remarks: "",
    isApproved: 0,
    isFinal: 0,
    dateCreated: new Date(),
    dateUpdated: new Date(),
    isActive: 1,
    isDeleted: 0,

    // owner: "",
    // code: "",
    // topicType: "",
    // concernArea: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const mode = assignmentId === undefined ? "add" : "update";

  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    if (mode === "update") {
      const config = { url: `/assignment/${assignmentId}`, method: "get", headers: { Authorization: authState.token } };
      fetchData(config, { showSuccessToast: false }).then((data) => {
        setAssignment(data.assignment);
        const jsDateCreated = new Date(data.assignment.dateCreated);
        const formattedDateCreated = `${jsDateCreated.getDate().toString().padStart(2, '0')}-${(jsDateCreated.getMonth() + 1).toString().padStart(2, '0')}-${jsDateCreated.getFullYear()}`;
        const jsDateUpdated = new Date(data.assignment.dateUpdated);
        const formattedDateUpdated = `${jsDateUpdated.getDate().toString().padStart(2, '0')}-${(jsDateUpdated.getMonth() + 1).toString().padStart(2, '0')}-${jsDateUpdated.getFullYear()}`;

        setFormData({
          userAssignmentID: data.assignment.userAssignmentID,
          assignmentType: data.assignment.assignmentType,
          assignmentFor: data.assignment.assignmentFor,
          category: data.assignment.category,
          subCategory: data.assignment.subCategory,
          owner: data.assignment.owner,
          code: data.assignment.code,
          topicType: data.assignment.topicType,
          concernArea: data.assignment.concernArea,
          problemStatement: data.assignment.problemStatement,
          why1: data.assignment.why1,
          why2: data.assignment.why2,
          why3: data.assignment.why3,
          why4: data.assignment.why4,
          why5: data.assignment.why5,
          rootCause: data.assignment.rootCause,
          summary: data.assignment.summary,
          remarks: data.assignment.remarks,
          isApproved: data.assignment.isApproved,
          isFinal: data.assignment.isFinal,
          dateCreated: formattedDateCreated,
          dateUpdated: formattedDateUpdated,
          isActive: data.assignment.isActive,
          isDeleted: data.assignment.isDeleted,
        });
      })
      .catch((error) => {
        console.error("Error fetching assignment data:", error);
        setError("Failed to fetch assignment data. Please try again later.");
      });
    }
  }, [mode, authState, assignmentId, fetchData]);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  }

  const handleReset = e => {
    e.preventDefault();
    if (assignment) {
      setFormData(prevData => ({
        ...prevData,
        ...assignment,
        dateCreated: assignment.dateCreated.toISOString(),
        dateUpdated: assignment.dateUpdated.toISOString()
      }));
    }
  }

  const handleSubmit = e => {
    e.preventDefault();
    const errors = validateForm(formData);
  
    setFormErrors({});
  
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
  
    const navigateToAssignmentList = () => {
      navigate("/assignments-think5whys");
    };
  
    if (mode === "add") {
      const config = { url: "/assignment", method: "post", data: formData, headers: { Authorization: authState.token } };
      fetchData(config)
        .then(() => {
          navigateToAssignmentList();
        })
        .catch((error) => {
          console.error("Error adding Assignment:", error);
          setError("Error adding Assignment");
        });
    } else {
      const config = { url: `/assignment/${assignmentId}`, method: "put", data: formData, headers: { Authorization: authState.token } };
      fetchData(config)
        .then(() => {
          navigateToAssignmentList();
        })
        .catch((error) => {
          console.error("Error updating Assignment:", error);
          setError("Error updating Assignment");
        });
    }
  };

  const validateForm = formData => {
    const errors = {};
    if (!formData.concernArea) {
      errors.concernArea = "Conern Area/Goal Title is required";
    } else if (formData.concernArea.length > 100) {
      errors.concernArea = "Conern Area/Goal Title cannot exceed 100 characters";
    }
    if (!formData.problemStatement) {
      errors.problemStatement = "Statement is required";
    } else if (formData.problemStatement.length > 1000) {
      errors.problemStatement = "Statement cannot exceed 1000 characters";
    }
    if (!formData.why1) {
      errors.why1 = "Why1 input is required";
    } else if (formData.why1.length > 1000) {
      errors.why1 = "Why1 cannot exceed 1000 characters";
    }
    if (!formData.why2) {
      errors.why2 = "Why2 input is required";
    } else if (formData.why2.length > 1000) {
      errors.why2 = "Why2 cannot exceed 1000 characters";
    }
    if (!formData.why3) {
      errors.why3 = "Why3 input is required";
    } else if (formData.why3.length > 1000) {
      errors.why3 = "Why3 cannot exceed 1000 characters";
    }
    if (!formData.why4) {
      errors.why4 = "Why4 input is required";
    } else if (formData.why4.length > 1000) {
      errors.why4 = "Why4 cannot exceed 1000 characters";
    }
    if (!formData.why5) {
      errors.why5 = "Why5 input is required";
    } else if (formData.why5.length > 1000) {
      errors.why5 = "Why5 cannot exceed 1000 characters";
    }
    if (!formData.rootCause) {
      errors.rootCause = "Root Cause input is required";
    } else if (formData.rootCause.length > 1000) {
      errors.rootCause = "Root Casue Statement cannot exceed 2000 characters";
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )


  return (
    <>
      <MainLayout>
      <div className="mt-12 min-h-screen py-8 bg-gradient-to-r from-teal-500 via-green-500 to-blue-500">
        <h3 className='text-2xl font-bold text-white text-center mb-2'>Assignments</h3>
        {/* </div> */}
        <form className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full'>
            {loading ? (
              <Loader />
            ) : (
              <div>
                {/* <h2 className="border-container" style={{ color: 'white', backgroundColor: 'darkblue' }}>{mode === "add" ? "Add" : "Edit"}</h2> */}
                <div className='flex justify-center'>
                  <h2 className="ml-2 text-xl text-yellow-200">{mode === "add" ? "Add" : "Edit"}</h2>
                </div>
                
                <div className="ml-4 mb-4 text-yellow-400">{formData.desc}</div>
                <input type="hidden" name="assignmentType" value={formData.assignmentType} />
                <input type="hidden" name="owner" value={formData.owner} />
                <input type="hidden" name="code" value={formData.code} />
                <input type="hidden" name="topicType" value={formData.topicType} />

                <div className="border-container">
                   {/* <div className="ml-4 mb-4 text-yellow-400">Complete Your Assignment</div> */}
                  <div className="mb-4">
                    <label htmlFor="concernArea">Complete Your Assignment for Area of Concern / Goal*:
                    <input
                      type="text"
                      name="concernArea"
                      id="concernArea"
                      value={formData.concernArea}
                      placeholder="Input Concern / Goal"
                      onChange={handleChange}
                      maxLength="100"
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        boxSizing: 'border-box',
                      }}
                    />
                    </label>
                    {fieldError("concernArea")}
                  </div>
                </div>

                <div className="border-container">
                  <div className="mb-4 flex flex-col">
                    <label>Statement*:</label>
                     <textarea
                      type="problemStatement"
                      name="problemStatement"
                      id="problemStatement"
                      value={formData.problemStatement}
                      placeholder="Write here.."
                      onChange={handleChange}
                      maxLength="1000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '650px', 
                        maxHeight: '150px' 
                      }}
                    />
                    {fieldError("problemStatement")}
                  </div>
                </div>

                <div className="border-container">
                  <div className="mb-4 flex flex-col">
                    <label>Why1*:</label>
                    <textarea
                      type="why1"
                      name="why1"
                      id="why1"
                      value={formData.why1}
                      placeholder="Write here.."
                      onChange={handleChange}
                      maxLength="1000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '650px', 
                        maxHeight: '150px' 
                      }}
                    />
                    {fieldError("why1")}
                  </div>
                </div>

                <div className="border-container">
                <div className="mb-4 flex flex-col">
                    <label htmlFor="why2">Why2*:</label>
                    <textarea
                      type="why2"
                      name="why2"
                      id="why2"
                      value={formData.why2}
                      placeholder="Write here.."
                      onChange={handleChange}
                      maxLength="1000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '650px', 
                        maxHeight: '150px' 
                      }}
                    />
                    {fieldError("why2")}
                  </div>
                </div>

                <div className="border-container">
                  <div className="mb-4 flex flex-col">
                    <label htmlFor="why3">Why3*:</label>
                    <textarea
                      type="why3"
                      name="why3"
                      id="why3"
                      value={formData.why3}
                      placeholder="Write here.."
                      onChange={handleChange}
                      maxLength="1000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '650px', 
                        maxHeight: '150px' 
                      }}
                    />
                    {fieldError("why3")}
                  </div>
                </div>

                <div className="border-container">
                  <div className="mb-4 flex flex-col">
                    <label htmlFor="why4">Why4*:</label>
                    <textarea
                      type="why4"
                      name="why4"
                      id="why4"
                      value={formData.why4}
                      placeholder="Write here.."
                      onChange={handleChange}
                      maxLength="1000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '650px', 
                        maxHeight: '150px' 
                      }}
                    />
                    {fieldError("why4")}
                  </div>
                </div>

                <div className="border-container">
                  <div className="mb-4 flex flex-col">
                    <label htmlFor="why5">Why5*:</label>
                    <textarea
                      type="why5"
                      name="why5"
                      id="why5"
                      value={formData.why5}
                      placeholder="Write here.."
                      onChange={handleChange}
                      maxLength="1000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '650px', 
                        maxHeight: '150px' 
                      }}
                    />
                    {fieldError("why5")}
                  </div>
                </div>

                <div className="border-container">
                  <div className="mb-4 flex flex-col">
                    <label htmlFor="rootCause">Root Cause*:</label>
                    <textarea
                      type="rootCause"
                      name="rootCause"
                      id="rootCause"
                      value={formData.rootCause}
                      placeholder="Write here.."
                      onChange={handleChange}
                      maxLength="1000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '650px', 
                        maxHeight: '150px' 
                      }}
                    />
                    {fieldError("rootCause")}
                  </div>
                </div>
                <div className="border-container flex flex-col justify-center">
                  <div className="flex justify-center">
                    {Object.keys(formErrors).length > 0 && (
                      <div className="form-errors text-red-300 justify-center items-center">
                        {Object.keys(formErrors).map((key) => (
                          <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className='flex justify-center'>
                    <button className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' onClick={handleSubmit}>{mode === "add" ? "Add New" : "Update"}</button>
                    <button className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' onClick={() => navigate("/assignments-think5whys")}>Cancel</button>
                    {mode === "update" && <button className='ml-4 bg-blue-500 text-white px-4 py-2 font-medium hover:bg-blue-600' onClick={handleReset}>Reset</button>}
                  </div>
                </div>
              </div>
            )}
          </form>
        </div>
      </MainLayout>
    </>
  )
}

export default Assignment